import { Button, Heading, Section } from 'components'
import React from 'react'

const TempFeaturesCta = () => {
  return (
    <Section background="bg-gray-100" className="text-center">
      <div className="max-w-3xl mx-auto">
        <Heading level="3">
          Don’t miss the chance to connect with visitors and automatically
          identify new leads.
        </Heading>
        <Button type="primary" to="/demo">
          Schedule a Demo
        </Button>
      </div>
    </Section>
  )
}

export default TempFeaturesCta
